// Lib
import React from 'react';
import Box from '@mui/material/Box';

import { Typography } from '@mui/material';
// Components
import Button from '../../../components/Button';
import Layout from '../../../components/Layout';

// URLS
import { BASE_URL, SSO_LOGIN_PAGE } from '../../../constants/urls';

import { useStyles } from './LogoutStyles';

const Logout = () => {
  const { classes } = useStyles();

  const onClick = () => {
    window.location.href = `${BASE_URL}${SSO_LOGIN_PAGE}`;
  };

  return (
    <Layout hideHeaderLinks={true} className={{ layout: classes.layout }}>
      <Box display="flex" alignItems="center" flexDirection="column">
        <Typography className={classes.text} variant="h1">
          You have logged out of GMOP.
        </Typography>
        <Button id="sign-back" onClick={onClick} className={classes.button}>
          Sign back
        </Button>
      </Box>
    </Layout>
  );
};

export default Logout;
